import wixLocation from 'wix-location';
import wixWindow from 'wix-window';


$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
		$w('#mobileTest').show()
		.then(() => $w('#mobileTest').expand())
} 

});
let fadeOutOptions = {
	"duration": 100,
	"delay": 0
};
let fadeInOptions = {
	"duration": 300,
	"delay": 0
};

const validateEmailInput = (inputText) => {
	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	if (inputText.match(mailformat)) return true;
	else return false;
}

const showEmailInputWarning = () => {
	$w('#emailInputWarning').show('fade', fadeOutOptions);
	setTimeout(() => $w('#emailInputWarning').hide('fade', fadeOutOptions), 5000)
}

export function button78_click(event) {
	//Add your code for this event here: 
	const email = $w('#input1').value;
	validateEmailInput(email) ? wixLocation.to(`https://info.wixanswers.com/unified_product_demo?email=${email}`) : showEmailInputWarning();
}


const showOneInboxBox = () => {
	if ($w('#oneInboxBox').isVisible) return;
	$w('#singleTimelineBtn, #agentReplyBtn, #customerInfoBtn').disable()
		.then($w('#singleTimelineBox, #agentReplyBox, #customerInfoBox').hide('fade', fadeOutOptions))
		.then($w('#singleTimelineBtn, #agentReplyBtn, #customerInfoBtn').style.backgroundColor = '#FFF7F2')
		.then($w('#oneInboxBox').show('fade', fadeInOptions))
		.then($w('#oneInboxBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#singleTimelineBtn, #agentReplyBtn, #customerInfoBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}
const showSingleTimelineBox = () => {
	if ($w('#singleTimelineBox').isVisible) return;
	$w('#oneInboxBtn, #agentReplyBtn, #customerInfoBtn').disable()
		.then($w('#oneInboxBox, #agentReplyBox, #customerInfoBox').hide('fade', fadeOutOptions))
		.then($w('#oneInboxBtn, #agentReplyBtn, #customerInfoBtn').style.backgroundColor = '#FFF7F2')
		.then($w('#singleTimelineBox').show('fade', fadeInOptions))
		.then($w('#singleTimelineBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#oneInboxBtn, #agentReplyBtn, #customerInfoBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}
const showAgentReplyBox = () => {
	if ($w('#agentReplyBox').isVisible) return;
	$w('#singleTimelineBtn, #oneInboxBtn, #customerInfoBtn').disable()
		.then($w('#singleTimelineBox, #oneInboxBox, #customerInfoBox').hide('fade', fadeOutOptions))
		.then($w('#singleTimelineBtn, #oneInboxBtn, #customerInfoBtn').style.backgroundColor = '#FFF7F2')
		.then($w('#agentReplyBox').show('fade', fadeInOptions))
		.then($w('#agentReplyBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#singleTimelineBtn, #oneInboxBtn, #customerInfoBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}
const showCustomerInfoBox = () => {
	if ($w('#customerInfoBox').isVisible) return;
	$w('#singleTimelineBtn, #agentReplyBtn, #oneInboxBtn').disable()
		.then($w('#singleTimelineBox, #agentReplyBox, #oneInboxBox').hide('fade', fadeOutOptions))
		.then($w('#singleTimelineBtn, #agentReplyBtn, #oneInboxBtn').style.backgroundColor = '#FFF7F2')
		.then($w('#customerInfoBox').show('fade', fadeInOptions))
		.then($w('#customerInfoBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#singleTimelineBtn, #agentReplyBtn, #oneInboxBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}


export function oneInboxBtn_click(event) {
	showOneInboxBox()
}


export function singleTimelineBtn_click(event) {
	showSingleTimelineBox() 
}


export function agentReplyBtn_click(event) {
	showAgentReplyBox() 
}

export function customerInfoBtn_click(event) {
	showCustomerInfoBox() 
}






export function box1_click(event) {
	wixLocation.to('https://www.wixanswers.com/support-leaders-whitepaper-2020?utm_source=website&utm_medium=homepage&utm_campaign=whitepaper&utm_content=registration_link');
}

export function box2_click(event) {
	wixLocation.to('https://www.wixanswers.com/post/elevate-your-support-product-expert-teams?utm_source=website&utm_medium=homepage&utm_campaign=blog_promotion&utm_content=elevate-your-support-product-expert-teams');
}

export function box3_click(event) {
	wixLocation.to('https://www.wixanswers.com/post/wix-alon-mor-self-service-business?utm_source=website&utm_medium=homepage&utm_campaign=blog_promotion&utm_content=wix-alon-mor-self-service-business');
}


